var map = {
	"./svg/coupon.svg": 67422,
	"./svg/member.svg": 70008,
	"./svg/msg.svg": 22217,
	"./svg/org.svg": 15743,
	"./svg/product.svg": 16967,
	"./svg/store.svg": 78149,
	"./svg/sysconfig.svg": 60060,
	"./svg/今天.svg": 39034,
	"./svg/优惠券.svg": 91542,
	"./svg/会员绑定.svg": 99651,
	"./svg/余额支付.svg": 71048,
	"./svg/全部订单.svg": 53897,
	"./svg/公告.svg": 26924,
	"./svg/分类.svg": 82816,
	"./svg/列表.svg": 78842,
	"./svg/到院管理.svg": 90389,
	"./svg/发货管理.svg": 89409,
	"./svg/发送短信.svg": 55133,
	"./svg/售后管理.svg": 73012,
	"./svg/商品.svg": 21868,
	"./svg/商品分类.svg": 82353,
	"./svg/商品列表.svg": 40161,
	"./svg/商城管理.svg": 36049,
	"./svg/回访.svg": 19070,
	"./svg/回访管理.svg": 52742,
	"./svg/图片.svg": 51664,
	"./svg/图片橱窗.svg": 18297,
	"./svg/在线客服.svg": 82020,
	"./svg/备案号.svg": 67073,
	"./svg/复制.svg": 20913,
	"./svg/复诊.svg": 46790,
	"./svg/复诊管理.svg": 16939,
	"./svg/定时任务.svg": 33001,
	"./svg/客户管理.svg": 67387,
	"./svg/客群.svg": 9620,
	"./svg/富文本框.svg": 32890,
	"./svg/对号.svg": 59432,
	"./svg/导出.svg": 96108,
	"./svg/已提现.svg": 86732,
	"./svg/录音管理.svg": 50711,
	"./svg/待回访.svg": 84466,
	"./svg/微信支付.svg": 65882,
	"./svg/我的.svg": 39288,
	"./svg/提醒.svg": 94088,
	"./svg/搜索.svg": 97546,
	"./svg/支付宝.svg": 28814,
	"./svg/数据.svg": 96694,
	"./svg/文档.svg": 75700,
	"./svg/文章.svg": 10858,
	"./svg/日志记录.svg": 25315,
	"./svg/未提现.svg": 74235,
	"./svg/权限.svg": 81140,
	"./svg/板块.svg": 89917,
	"./svg/板块内容.svg": 2489,
	"./svg/板块商品.svg": 95229,
	"./svg/案例图片.svg": 86175,
	"./svg/检查报告查询.svg": 57354,
	"./svg/治疗套餐.svg": 82132,
	"./svg/治疗客户.svg": 43391,
	"./svg/治疗管理.svg": 69661,
	"./svg/热区.svg": 98089,
	"./svg/物流.svg": 20300,
	"./svg/用户列表.svg": 46101,
	"./svg/用户卡券.svg": 75155,
	"./svg/电话.svg": 29307,
	"./svg/电话回访.svg": 86363,
	"./svg/短信服务.svg": 38542,
	"./svg/短信模版.svg": 5537,
	"./svg/短信群发.svg": 71853,
	"./svg/短信记录.svg": 95594,
	"./svg/空白.svg": 81289,
	"./svg/统计分析.svg": 89899,
	"./svg/自助预约.svg": 36832,
	"./svg/菜单.svg": 96269,
	"./svg/规格.svg": 437,
	"./svg/视频.svg": 67416,
	"./svg/角色.svg": 36058,
	"./svg/订单.svg": 59443,
	"./svg/订单金额.svg": 2383,
	"./svg/账号.svg": 95947,
	"./svg/资金明细.svg": 19850,
	"./svg/轮播图.svg": 17089,
	"./svg/辅助线.svg": 19149,
	"./svg/部门.svg": 4490,
	"./svg/错误.svg": 66018,
	"./svg/院内管理.svg": 80050,
	"./svg/预约管理.svg": 37595,
	"./svg/预计.svg": 67436,
	"./svg/预计到院.svg": 73263,
	"./svg/首页.svg": 61948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52064;